export default __webpack_public_path__ + "static/media/gallery_05.8d6e01b7.jpg";